// @flow
import { _get, _post, _put, _delete, _upload } from "./methods";

export default {
  list: (filter: any) => _get("/admin/running_routes", filter),
  get: (route_id: number) => _get(`/admin/running_routes/${route_id}`),
  create: (data: any) => _post("/admin/running_routes", data),
  update: ({ route_id, ...data }: any) =>
    _put(`/admin/running_routes/${route_id}`, data),
  delete: ({ route_id }: any) => _delete(`/admin/running_routes/${route_id}`),
  uploadHeroImage: ({
    route_id,
    file
  }: {
    route_id: number,
    file: Blob
  }) => _upload(`/admin/running_routes/${route_id}/hero`, file, "image")
};
